<template>
  <b-container>
    <h1>Checkout</h1>
    <b-form v-on:submit.prevent="submitOrder">
      <b-form-group label="Table Number / location (required)">
        <b-overlay :show="init_loading" opacity="0.6">
          <multiselect placeholder="Select table number" trackBy="table_no" label="table_no" :multiple="false"
                       :options="tables"
                       v-model="table_no"></multiselect>
        </b-overlay>
        <b-form-invalid-feedback v-if="errors.table_no">{{ errors.table_no[0] }}</b-form-invalid-feedback>
      </b-form-group>

      <b-form-group label="Customer Name">
        <b-form-input type="text" v-model="customer_name"></b-form-input>
        <b-form-invalid-feedback v-if="errors.customer_name">{{ errors.customer_name[0] }}</b-form-invalid-feedback>
      </b-form-group>

      <b-form-group label="Customer Tel Number">
        <b-form-input type="text" v-model="customer_tel_number"></b-form-input>
        <b-form-invalid-feedback v-if="errors.customer_tel_number">{{ errors.customer_tel_number[0] }}</b-form-invalid-feedback>
      </b-form-group>

      <b-form-group label="Additional comments">
        <b-form-textarea :maxlength="50" v-model="additional_comments"></b-form-textarea>
        <b-form-invalid-feedback>{{ (50 - additional_comments.length) }} characters left.</b-form-invalid-feedback>
        <b-form-invalid-feedback v-if="errors.additional_comments">{{errors.additional_comments[0] }}
        </b-form-invalid-feedback>
      </b-form-group>

      <table class="table">
        <tr>
          <th>Sub-total</th>
          <td>£{{ formatMoney(this.sub_total) }}</td>
        </tr>
        <tr>
          <th>Total</th>
          <td>£{{ formatMoney(this.total) }}</td>
        </tr>
      </table>

      <b-form-group label="Cash Received">
        <b-form-input v-on:input="calculate_change" step="any" type="number" pattern="[0-9]*" inputmode="decimal"
                      v-model="cash_received"></b-form-input>
      </b-form-group>

      <b-form-group label="Change Due">
        <b-form-input readonly v-on:input="calculate_change" step="any" type="number" pattern="[0-9]*" inputmode="decimal"
                      v-model="change_due"></b-form-input>
      </b-form-group>

      <b-form-group>
        <b-button size="lg" variant="primary" block disabled v-if="loading">
          <b-spinner small type="grow"></b-spinner>
          Sending...
        </b-button>
        <b-button type="submit" size="lg" v-else variant="primary" block>Send Order</b-button>
      </b-form-group>
    </b-form>
  </b-container>
</template>

<script>
import Multiselect from 'vue-multiselect'
import {mapGetters} from "vuex";
import store from "@/store";

export default {
  name: "CheckoutWaiter",

  data() {
    return {
      service_charge: '',
      init_loading: false,
      tables: [],
      table_no: '',
      customer_name: '',
      customer_tel_number: '',
      additional_comments: '',
      errors: [],
      total: 0,
      sub_total: 0,
      cash_received: 0,
      change_due: 0,
      loading: false,
    }
  },

  components: {Multiselect},

  computed: {
    ...mapGetters([
      'getProductsInCart',
    ]),
  },

  mounted() {
    this.getSettings()
  },

  methods: {
    getSettings() {
      this.init_loading = true;
      axios.get('/settings/system').then(response => {
        this.service_charge = response.data.service_charge;
        this.init_loading = false;
        this.createSubTotal(this.service_charge);
        this.getAvailableTables();
      })
    },
    getAvailableTables() {
      axios.get('/settings/table-settings/available-tables').then(response => {
        this.tables = response.data.tables;
      })
    },

    formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
      try {
        decimalCount = Math.abs(decimalCount);
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

        const negativeSign = amount < 0 ? "-" : "";

        let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
        let j = (i.length > 3) ? i.length % 3 : 0;

        return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
      } catch (e) {
        console.log(e)
      }
    },

    createSubTotal(service_charge) {
      new Promise((resolve, reject) => {
        let sum = 0;
        this.getProductsInCart.forEach(function (item) {
          sum += parseFloat(item.total);
        });
        resolve(sum);
      }).then((sum) => {
        console.log('sum', sum)
        this.sub_total = sum
        this.total = +sum + +service_charge;
        this.total_wo_tip = this.total;
      });
    },

    calculate_change(){
      this.change_due = this.formatMoney(this.cash_received - this.total);
    },

    submitOrder(){
      this.loading = true;
      let orderData =  {
        waiter_order: 1,
        table_no: this.table_no.table_no,
        customer_name: this.customer_name,
        customer_tel_number: this.customer_tel_number,
        additional_comments: this.additional_comments,
        productData: this.getProductsInCart,
        sub_total: this.formatMoney(this.sub_total),
        total: this.formatMoney(this.total),
        cash_received: this.formatMoney(this.cash_received),
        change_due: this.formatMoney(this.change_due),
      }

      axios.post('/checkout/waiter/send', orderData).then(response => {
        this.loading = false;
        this.$toasted.show(response.data.message);
        store.commit('REMOVE_ALL_PRODUCTS');
        this.$router.push({path: '/'});
      }).catch(error => {
        this.loading = false;
        this.errors = error.response.data.errors;
      })
    }
  }
}
</script>

<style scoped>

</style>